import { render, staticRenderFns } from "./SubstanceListsWithQuestions.vue?vue&type=template&id=e0a37ad4&"
import script from "./SubstanceListsWithQuestions.vue?vue&type=script&lang=js&"
export * from "./SubstanceListsWithQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports